import useMutation from 'api/hooks/useMutation';
import permissions from 'api/Apollo/permissions';
import { PIPELINE_TAGS_QUERY } from 'api/pipeline-tags/useQueryPipelineTags';
import { PIPELINES_QUERY } from 'api/pipelines/pipelines-query-builder';

import {
  mutation as removeTagFromPipelineMutation,
  buildVariables as buildRemoveVariables,
} from './remove-tag-from-pipeline-mutation-builder';

export default function useRemoveTagFromPipeline(options = {}) {
  const [executeMutation, response] = useMutation(removeTagFromPipelineMutation, {
    context: { permission: permissions.writeTags },
    refetchQueries: [PIPELINE_TAGS_QUERY, PIPELINES_QUERY],
    ...options,
  });

  const removeTagFromPipeline = ({ pipelineId, tag }) => {
    return executeMutation(buildVariables({ pipelineId, tag }));
  };

  return [removeTagFromPipeline, response];
}

function buildVariables({ pipelineId, tag }) {
  return {
    variables: buildRemoveVariables({ pipelineId, tagId: tag.id }),
  };
}
